import { memo, useState } from "react";
import { toast } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import MasterAPI from "service/master";

const Accept = props => {
    const { data, mutate } = props;
    const [loading, setLoading] = useState(false);

    const clickHandler = async () => {
        if (loading)
            return;

        setLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/v2/financial/order/change_status",
                payloadType: 3,
                method: "PUT",
                data: {
                    id: data.id,
                    status_id: 2
                },
                callback: () => setLoading(false)
            });

            toast.success(res.message);
            mutate();
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <button
            className={`bg-primary-100 hover:bg-primary-200 px-3 transition-colors text-white rounded-md fit-center text-sm h-10 mr-2 relative overflow-hidden${loading ? " cursor-progress" : ""}`}
            onClick={clickHandler}
        >
            <i className="fa-light fa-pen-to-square ml-2"></i>
            تایید سفارش

            <CSSTransition in={loading} timeout={200} unmountOnExit={true}>
                <span className="pos-cover bg-primary-200 fit-center anim-c4">
                    <i className="fa-solid fa-spinner spin"></i>
                </span>
            </CSSTransition>
        </button>
    )
}

export default memo(Accept);